import React from "react";
import { useFormContext } from "react-hook-form";
import { ExpandMore } from "@mui/icons-material";
import ExlyInput from "repoV2/features/Common/modules/Form/modules/ExlyInput/ExlyInput";
import ExlySearchableDropdown from "repoV2/features/Common/modules/Form/modules/ExlySearchableDropdown/ExlySearchableDropdown";
import { classNames } from "repoV2/utils/common/render/classNames";
import { ISingleSelectDropdown } from "./SingleSelectDropdown.interfaces";

const SingleSelectDropdown = (props: ISingleSelectDropdown) => {
    const {
        name,
        options,
        placeholder,
        validator,
        onChange,
        otherOptionValue,
        customOtherPlaceholder,
        customOtherName,
        customOtherOnBlur,
        customOtherValidator,
        classes = {},
    } = props;

    const { getValues } = useFormContext();
    const data = getValues();
    // Incase of multiple users, we have to show prefilled values of dropdown,
    // This value is the value of 'Other' field when this option is selected.
    const preFilledOtherValue = customOtherName ? data?.[customOtherName] : "";
    const preFilledSelectValue = name ? data?.[name] : "";

    // Initially, if user had selected 'Other', then we check if other field had some value
    // also, verify that 'Other' is actually selected in the dropdown as well
    const [showCustomOtherOption, setShowCustomOtherOption] = React.useState(
        Boolean(preFilledOtherValue) &&
            preFilledSelectValue === otherOptionValue
    );

    return (
        <div
            className={classNames(
                classes.selectContainer,
                classes.dropdownBorderStyles
            )}
        >
            <ExlySearchableDropdown
                name={name}
                options={options}
                placeholder={placeholder}
                clearOnFocus
                classes={{
                    textInput: classNames(
                        classes.textInput,
                        showCustomOtherOption &&
                            classes.dropdownWithOtherTextStyle
                    ),
                    helperText: classes.dropdownHelperText,
                    placeholder: classes.placeholderText,
                    inputRoot: classes.inputRoot,
                    listbox: classes.listbox,
                }}
                registerOptions={{
                    validate: validator,
                }}
                onChange={option => {
                    if (option.value === otherOptionValue) {
                        setShowCustomOtherOption(true);
                    } else {
                        setShowCustomOtherOption(false);
                    }
                    onChange(option);
                }}
                ExpandIcon={<ExpandMore />}
            />
            {showCustomOtherOption && (
                <ExlyInput
                    name={customOtherName}
                    classes={{
                        helperText: classes.helperText,
                    }}
                    registerOptions={{
                        validate: customOtherValidator,
                    }}
                    overrideInputProps={{
                        placeholder: customOtherPlaceholder,
                        fullWidth: true,
                        onBlur: customOtherOnBlur,
                        InputProps: {
                            className: classNames(
                                classes.textInput,
                                classes.otherTextStyle
                            ),
                        },
                        className: classes.inputCustomStyles,
                    }}
                />
            )}
        </div>
    );
};

export default SingleSelectDropdown;
